/* Connect Storepass search while retaining native Shopify markup as a failure fallback. */
(() => {
  const integration = document.currentScript;
  const locationNames = new Map();
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = () => reject(new Error('Unable to load Storepass storefront search'));
      document.head.appendChild(script);
    });
  }
  function updateIntegration() {
    const searches = document.querySelectorAll('.store-pass-search-input');
    if (searches.length) document.body.classList.add('storepass-search-ready');
    searches.forEach((input) => { if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Search products'); });
    document.querySelectorAll('.store-pass-active-filter > span').forEach((label) => {
      if (!/^Location(?:_id)?:/i.test(label.textContent)) return;
      const selectedId = new URLSearchParams(window.location.search).get('location_id');
      const nextLabel = `Location: ${locationNames.get(selectedId) || (selectedId === 'All' ? 'All' : 'Selected location')}`;
      if (label.textContent !== nextLabel) label.textContent = nextLabel;
    });
    const shell = document.querySelector('[data-storepass-results-shell]');
    const native = document.querySelector('[data-storepass-native-results]');
    const status = document.querySelector('[data-storepass-results-status]');
    if (!shell || !native || !status) return;
    const counts = Array.from(shell.querySelectorAll('.store-pass-results-count'));
    const ready = Boolean(shell.querySelector('.store-pass-product')) || counts.some((count) => count.textContent.trim());
    const failed = Boolean(shell.querySelector('[role="alert"]')) || Array.from(shell.querySelectorAll('.store-pass-products-section > div')).some((item) => /^Error:/.test(item.textContent.trim()));
    if (failed) {
      const message = 'Storepass search is unavailable. Shopify results below do not include location filters.';
      if (status.textContent !== message) status.textContent = message;
      status.hidden = false;
      native.hidden = false;
      shell.hidden = true;
    } else if (ready) {
      shell.hidden = false;
      native.hidden = true;
      status.hidden = true;
    }
  }
  async function initialize() {
    new MutationObserver(updateIntegration).observe(document.body, { childList: true, subtree: true });
    if (!window.jQuery) await loadScript(integration.dataset.jqueryUrl);
    window.$ = window.jQuery;
    const settings = document.getElementById('storepass-search-settings-json');
    try {
      const response = await fetch(settings.dataset.url);
      if (!response.ok) throw new Error('Unable to read location names');
      const payload = await response.json();
      (payload.store?.locations || []).forEach((location) => { locationNames.set(String(location.id), location.name); });
    } catch (error) { console.warn('Storepass location labels:', error); }
    await loadScript(integration.dataset.loaderUrl);
    updateIntegration();
  }
  initialize().catch((error) => {
    console.error('Storepass search initialization failed:', error);
    const status = document.querySelector('[data-storepass-results-status]');
    if (status) status.textContent = 'Showing Shopify results. Location filters are temporarily unavailable.';
  });
})();
